<template>
	<div>

		<breadcrumbs />

		<loading :active.sync="isLoading"></loading>

    <div class="matching-area">
      <div class="row">
        <div class="col-6">
          <table class="table table-bordered table-lg table-v2 table-striped">
            <tbody>
            <tr v-for="l in liveEvents">
              <td>{{ l.name }} ({{ l.targetId }})</td>
              <td>
                <a href="javascript:;" @click="selectTarget(l.targetId)">
                  <i class="os-icon os-icon-crosshair"></i>
                </a>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
        <div class="col-6">
          <a href="javascript:;" @click="hideAllCompetitors()" class="btn btn-warning">Hide All</a>
          <table class="table table-bordered table-lg table-v2 table-striped">
            <tbody>
              <tr v-for="g in geniusEvents">
                <td>
                  <a href="javascript:;" v-show="target" @click="selectMatched(g.matched)">
                    <i class="os-icon os-icon-anchor"></i>
                  </a>
                </td>
                <td>{{ g.name }} ({{ g.matched }}) - {{ g.provider.name }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

	</div>
</template>

<script>
    export default {
        name: 'hello',
        data () {
            return {
              t: this.$root.t,
              geniusEvents: [],
              liveEvents: [],
              matched: null,
              target: null
            }
        },
      watch: {
          'matched' () {
              this.saveRelation();
          }
      },
      mounted (){
        this.fetchLiveCompetitors();
        this.fetchGeniusEvents()
      },
      methods: {
        selectMatched(id){

          if(this.matched == id){
            this.matched = null;
          }else {
            this.matched = id
          }

        },
        selectTarget(id){
          if(this.target == id){
            this.target = null;
          }else {
            this.target = id
          }

        },
        async saveRelation () {
          this.$http.post(bsapi+'api/v1/save/competitor-relation', {
            matched: this.matched,
            target: this.target
          })
            .then(response => {

            }, response => {
              this.notfound = 1;
            })
        },
        async hideAllCompetitors () {

          this.$http.get(bsapi+'api/v1/genius/hide-all')
            .then(response => {

              this.geniusEvents = [];
            }, response => {
              this.notfound = 1;
            })
        },
        async fetchGeniusEvents () {
          this.$http.get(bsapi+'api/v1/genius/event-list')
            .then(response => {

              this.geniusEvents = response.body.result;
            }, response => {
              this.notfound = 1;
            })
        },
        async fetchLiveCompetitors () {
          this.$http.get(bsapi+'api/v1/genius/live-list')
            .then(response => {

              this.liveEvents = response.body.result;
            }, response => {
              this.notfound = 1;
            })
        }
      }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.col-6 {
  height: 100vh;
  overflow: scroll;
}
.matching-area {
  width: 100vw;
  height: 100vh;
  position: fixed;
  left: 0;
  top: 0;
  background: white;
  z-index: 99;

}
</style>



// WEBPACK FOOTER //
// src/components/feed/genius/matching.vue